import {
  resetAttribute,
  sortArray,
  getDistinct,
  getSameAttribute,
  getLevelArray,
  isDirtyDictLabel
} from '@/utils/handleData.js'
import { uniqueWorkContentTree } from '@/utils/eduWorkContent.js'
import { getLaborParentBidUid } from '@/utils/bidLevelActions.js'
export default {
  namespaced: true,
  state: {
    subitemType: [], // 缓存分部分项划分类型
    riskWorks: [], // 缓存当前分部分项默认风险作业类型选项
    progressItemType: [], // 缓存当前分部分项默认进度分项类型选项
    concealedWorks: [], // 缓存当前分部分项中选择进度分项默认隐蔽工程工序选项
    listHook: [], // 缓存当前分部分项中选择进度分项默认清单挂接选项
    subitemList: [], // 缓存当前选择机构的工程分部分项划分
    subprojects: [], // 缓存当前选择机构的所有分部工程
    subitemInfo: {}, // 缓存分部分项数据信息
    structureSize: {}, // 缓存当前分项工程工程结构模型数据
    workContentAndRisk: [] // 缓存当前分项工程所涉及的风险作业内容
  },
  getters: {
    progressSubitem: (state) => {
      var progressSubitem = JSON.parse(JSON.stringify(state.subitemList))
      for (let index = 0; index < progressSubitem.length; index++) {
        const item = progressSubitem[index]
        if (!item.children || !item.children.length) {
          progressSubitem.splice(index, 1)
          index--
        } else {
          for (let num = 0; num < item.children.length; num++) {
            const child = item.children[num]
            if (!child.children || !child.children.length) {
              item.children.splice(num, 1)
              num--
            } else {
              for (let code = 0; code < child.children.length; code++) {
                const sub = child.children[code]
                if (!sub.progressItemNum) {
                  child.children.splice(code, 1)
                  code--
                }
              }
            }
          }
        }
      }
      return progressSubitem
    }
  },
  actions: {
    // 获取分部分项类型
    async getSubitemType({ rootState, rootGetters, commit, dispatch }, uid) {
      const parentUid = uid
        ? uid
        : rootState.dictionarys.projectConfig.find((item) => {
            return item.label === rootGetters['user/projectType']
          }).value
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/dictionary/getsegmentsubitem',
          data: {
            projectType: rootGetters['user/projectType'],
            parentUid: parentUid
          }
        },
        { root: true }
      )
      // console.log(res)
      var subitemType = res.data ? sortArray(res.data, ['subitemCode']) : []
      subitemType.forEach((item) => {
        item.value = item.subitemUid
        item.label = item.subitemCode + '\xa0\xa0' + item.subitemType
        if (item.progressItems && item.progressItems.length) {
          item.progressItems.forEach((pro) => {
            pro.value = pro.progressUid
            pro.unit = pro.progressUnit
            pro.label =
              pro.progressItemCode +
              '\xa0\xa0' +
              pro.progressItemType +
              '\xa0\xa0\xa0' +
              0 +
              '\xa0' +
              pro.progressUnit
            pro.progressItemTypeUid = pro.progressUid
          })
          item.progressItems = sortArray(item.progressItems, [
            'progressItemCode'
          ])
        }
        if (item.riskWorks && item.riskWorks.length) {
          item.riskWorks.forEach((risk) => {
            risk.value = risk.riskUid
            risk.label = risk.riskUid + '\xa0\xa0' + risk.riskSource
          })
          item.riskWorks = sortArray(item.riskWorks, ['riskUid'])
        }
      })
      commit(
        'baseSet',
        { module: 'division', key: 'subitemType', value: subitemType },
        { root: true }
      )
      return subitemType
    },
    // 获取隐蔽工程及工程量清单类型
    async getProgressItemType(
      { rootState, rootGetters, commit, dispatch },
      progressUid
    ) {
      var progressItemType = []
      var concealedWorks = []
      var listHook = []
      if (progressUid) {
        const res = await dispatch(
          'baseRequest',
          {
            method: 'GET',
            url: '/organize/dictionary/getprogressitems',
            data: { progressUid: progressUid }
          },
          { root: true }
        )
        // console.log(res)
        progressItemType = res.data
          ? sortArray(res.data, ['progressItemCode'])
          : []
        progressItemType.forEach((item) => {
          item.orgUid = rootState.user.orgValue
          item.value = item.progressUid
          item.uid = item.progressUid
          item.codeName =
            item.progressItemCode + '\xa0\xa0' + item.progressItemType
          item.imageQuantity = 0
          item.label =
            item.progressItemCode +
            '\xa0\xa0' +
            item.progressItemType +
            '\xa0\xa0\xa0' +
            item.imageQuantity +
            '\xa0' +
            item.progressUnit
          item.progressItemTypeUid = item.progressUid
          item.unit = item.progressUnit
          item.listHook = []
          if (item.bOQItemJsons && item.bOQItemJsons.length) {
            item.bOQItemJsons.forEach((code) => {
              const billOfContract = JSON.parse(
                JSON.stringify(rootGetters['billOfQuantities/billOfContract'])
              )
              const subList = billOfContract.filter((list) => {
                return (
                  list.listBreakdownCode.includes(code.listBreakdownCode) &&
                  (list.contractQuantity || list.contractQuantity === 0)
                )
              })
              item.listHook = item.listHook.concat(subList)
            })
            item.listHook.forEach((list) => {
              list.parentUid = list.uid
              list.value = item.uid + list.uid
              list.uid = list.value
              list.progressUid = item.progressUid
              list.billCheckQuantity = 0
              list.label =
                item.codeName +
                '\xa0/\xa0' +
                list.codeName +
                '\xa0\xa0' +
                list.billCheckQuantity +
                '\xa0\xa0' +
                list.unit
            })
            listHook = listHook.concat(item.listHook)
          }
          item.concealedWorks = []
          if (item.concealedWorkJsons && item.concealedWorkJsons.length) {
            item.concealedWorkJsons.forEach((concealedWork) => {
              concealedWork.value =
                item.progressUid + concealedWork.concealedUid
              concealedWork.label =
                item.progressItemType + '/' + concealedWork.concealedWork
              concealedWork.progressUid = item.progressUid
            })
            item.concealedWorks = item.concealedWorkJsons
            concealedWorks = concealedWorks.concat(item.concealedWorks)
          }
        })
      }
      commit(
        'baseSet',
        { module: 'division', key: 'concealedWorks', value: concealedWorks },
        { root: true }
      )
      commit(
        'baseSet',
        { module: 'division', key: 'listHook', value: listHook },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'division',
          key: 'progressItemType',
          value: progressItemType
        },
        { root: true }
      )
      return progressItemType
    },
    // 获取工程分部分项划分列表
    async getSubitemList({ rootState, rootGetters, commit, dispatch }, uid) {
      const orgType = rootGetters['user/orgType']
      const currentOrgUid = rootState.user.orgValue
      let orgUid = uid
      if (orgType === 'laborCom' && (!uid || uid === currentOrgUid)) {
        orgUid =
          getLaborParentBidUid({
            orgType,
            orgValue: currentOrgUid,
            state: rootState,
            getters: rootGetters
          }) ||
          rootGetters['bidSection/currentLaborParentBidUid'] ||
          ''
      } else if (!orgUid) {
        orgUid =
          orgType === 'simPro'
            ? currentOrgUid
            : rootState.bidSection.subBidSection[0]
            ? rootState.bidSection.subBidSection[0].orgUid
            : ''
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/segmentsubitmes',
          data: { orgUid: orgUid }
        },
        { root: true }
      )
      // console.log(res)
      var subitemList = res.data ? res.data : []
      var subprojects = []
      subitemList.forEach((child) => {
        subprojects = child.children && subprojects.concat(child.children)
        child.subitemCN = child.subitemCode + '\xa0\xa0' + child.subitemName
        child.progressItem = child.children.length + '个分部工程'
        child.factorys = []
        child.notHaveSize = 0
        child.children &&
          child.children.forEach((item) => {
            item.subitemCN = item.subitemCode + '\xa0\xa0' + item.subitemName
            item.progressItem = item.children.length + '个分项工程'
            item.factorys = []
            item.notHaveSize = 0
            item.children.forEach((ele) => {
              ele.disabledButtons = [0]
              ele.subitemCN = ele.subitemCode + '\xa0\xa0' + ele.subitemName
              ele.progressItem =
                ele.progressItemNum +
                '个形象进度分项；\xa0\xa0' +
                ele.concealedWorkNum +
                '个隐蔽工程工序；\xa0\xa0' +
                ele.listHookNum +
                '条工程量复核清单'
              ele.jobManageInfo =
                (ele.factory
                  ? ele.factory.name +
                    '\xa0\xa0' +
                    ele.factory.adminName +
                    '\xa0\xa0' +
                    ele.factory.adminPhone +
                    '；'
                  : '') +
                (ele.riskWorkNum ? ele.riskWorkNum.length : 0) +
                '种风险作业类型'
              ele.sizes = ele.sizes ? ele.sizes : []
              const image = rootState.dictionarys.structureModel
                ? rootState.dictionarys.structureModel.find((item) => {
                    return item.structureModel === ele.structureModel
                  })
                : {}
              ele.structureSize = {
                structureModel: ele.structureModel,
                sizes: ele.sizes,
                image: image ? image.image : '',
                fileLists: image ? image.fileLists : { image: [] }
              }
              ele.structureData = ele.structureModel
                ? getSameAttribute(ele.sizes, 'info', '\xa0\xa0；').joinString
                : ele.progressItemNum
                ? '需完善'
                : '/'
              item.notHaveSize =
                !ele.structureModel && ele.progressItemNum
                  ? ++item.notHaveSize
                  : item.notHaveSize
              if (ele.factory) {
                item.factorys.push(ele.factory)
              }
            })
            item.jobManageInfo = getDistinct(item.factorys, 'uid')
              .map((factory) => {
                return (
                  factory.name +
                  '\xa0\xa0' +
                  factory.adminName +
                  '\xa0\xa0' +
                  factory.adminPhone
                )
              })
              .join('；')
            item.structureData = item.notHaveSize
              ? item.notHaveSize + '项不完善'
              : '/'
            child.notHaveSize = child.notHaveSize + item.notHaveSize
            child.factorys = child.factorys.concat(item.factorys)
          })
        child.jobManageInfo = getDistinct(child.factorys, 'uid')
          .map((factory) => {
            return (
              factory.name +
              '\xa0\xa0' +
              factory.adminName +
              '\xa0\xa0' +
              factory.adminPhone
            )
          })
          .join('；')
        child.structureData = child.notHaveSize
          ? child.notHaveSize + '项不完善'
          : '/'
      })
      subitemList = resetAttribute(subitemList, 'subitemCN', 'uid', 'children')
      subitemList = sortArray(subitemList, ['subitemCode'])
      subprojects = resetAttribute(subprojects, 'subitemCN', 'uid', 'children')
      subprojects = sortArray(subprojects, ['subitemCode'])
      commit(
        'baseSet',
        {
          module: 'division',
          key: 'subitemList',
          value: subitemList
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'division',
          key: 'subprojects',
          value: subprojects
        },
        { root: true }
      )
    },
    // 添加分部分项
    async addSubitem({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/temp/segmentsubitme',
          data: data,
          msg: '添加分部分项工程成功'
        },
        { root: true }
      )
      return res
    },
    // 获取分部分项信息
    async getSubitemInfo(
      { state, rootState, rootGetters, commit, dispatch },
      uid
    ) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/temp/segmentsubitme',
          data: { uid: uid ? uid : state.subitemInfo.uid }
        },
        { root: true }
      )
      // console.log(res)
      var subitemInfo = res.data ? res.data : {}
      subitemInfo.subitemCN =
        subitemInfo.subitemCode + '\xa0\xa0' + subitemInfo.subitemName
      subitemInfo.parentCN =
        subitemInfo.parentUid === rootState.user.orgValue
          ? rootGetters['user/orgName']
          : subitemInfo.parentCode + '\xa0\xa0' + subitemInfo.parentName
      subitemInfo.workArea = subitemInfo.workAreaUid
        ? subitemInfo.workAreaUid
        : {}
      subitemInfo.workAreaUid = subitemInfo.workArea.uid
      const image = rootState.dictionarys.structureModel
        ? rootState.dictionarys.structureModel.find((item) => {
            return item.structureModel === subitemInfo.structureModel
          })
        : {}
      subitemInfo.sizes = subitemInfo.sizes ? subitemInfo.sizes : []
      subitemInfo.structureSize = {
        structureModel: subitemInfo.structureModel,
        sizes: subitemInfo.sizes,
        image: image ? image.image : '',
        fileLists: image ? image.fileLists : { image: [] }
      }
      subitemInfo.structureData = getSameAttribute(
        subitemInfo.sizes,
        'info',
        '\xa0\xa0；'
      ).joinString
      subitemInfo.progressItems = subitemInfo.progressItems
        ? subitemInfo.progressItems
        : []
      subitemInfo.concealedWorks = subitemInfo.concealedWorks
        ? sortArray(subitemInfo.concealedWorks, [
            'concealedWork',
            'workFinishFlag'
          ])
        : []
      subitemInfo.concealedWorks.forEach((item) => {
        const progress = subitemInfo.progressItems.find((pro) => {
          return pro.uid === item.progressUid
        })
        item.value = item.uid
        item.label = progress.progressItemType + '/' + item.concealedWork
      })
      subitemInfo.listHook = subitemInfo.listHook ? subitemInfo.listHook : []
      subitemInfo.listHook.forEach((item) => {
        const progress = subitemInfo.progressItems.find((pro) => {
          return pro.uid === item.progressUid
        })
        item.value = item.uid
        item.codeName =
          item.listBreakdownCode + '\xa0\xa0' + item.listBreakdownName
        item.label =
          progress.progressItemCode +
          '\xa0\xa0' +
          progress.progressItemType +
          '\xa0/\xa0' +
          item.listBreakdownCode +
          '\xa0\xa0' +
          item.listBreakdownName +
          '\xa0\xa0' +
          item.billCheckQuantity +
          '\xa0\xa0' +
          item.unit
        item.quantity = item.billCheckQuantity
        item.listHookInfo = item.drawingNo ? item.drawingNo : ''
        item.concealedWorkInfo = item.marker ? item.marker : ''
      })
      subitemInfo.progressItems.forEach((item) => {
        item.value = item.uid
        item.codeName =
          item.progressItemCode + '\xa0\xa0' + item.progressItemType
        item.label =
          item.progressItemCode +
          '\xa0\xa0' +
          item.progressItemType +
          '\xa0\xa0\xa0' +
          item.imageQuantity +
          '\xa0' +
          item.unit
        item.quantity = item.imageQuantity
        item.concealedWorks = subitemInfo.concealedWorks.filter((concealed) => {
          return concealed.progressUid === item.uid
        })
        item.concealedWorkType = getDistinct(
          getSameAttribute(item.concealedWorks, 'concealedWork').values
        )
        item.concealedWorkInfo = item.concealedWorks.length
          ? '包含\xa0\xa0【' +
            item.concealedWorkType.join('、') +
            '】\xa0\xa0共' +
            item.concealedWorkType.length +
            '种/' +
            item.concealedWorks.length +
            '条隐蔽工程工序'
          : ''
        item.listHook = subitemInfo.listHook.filter((list) => {
          return list.progressUid === item.uid
        })
        item.children = item.listHook
        item.listHookInfo = item.listHook.length + '个工程量复核清单'
      })
      commit(
        'baseSet',
        {
          module: 'division',
          key: 'subitemInfo',
          value: subitemInfo
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'division',
          key: 'structureSize',
          value: subitemInfo.structureSize
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'division',
          key: 'progressItemType',
          value: subitemInfo.progressItems
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'division',
          key: 'concealedWorks',
          value: subitemInfo.concealedWorks
        },
        { root: true }
      )
      commit(
        'baseSet',
        {
          module: 'division',
          key: 'listHook',
          value: subitemInfo.listHook
        },
        { root: true }
      )
      return subitemInfo
    },
    // 编辑分部分项工程信息
    async editSubitemInfo({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/temp/segmentsubitme',
          data: data,
          msg: data.codeNameChange ? null : '编辑分部分项工程信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除分部分项数据
    async deleteSubitem({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/temp/segmentsubitme',
          data: { uid: uid },
          msg: '删除分部分项成功'
        },
        { root: true }
      )
      return res
    },
    // 获取当前分项工程所涉及的风险作业内容及相关风险源及防护措施
    async getWorkContentAndRisk({ commit, dispatch, rootState }, data = {}) {
      const query = {}
      if (data && data.workPlaceUid) {
        query.workPlaceUid = data.workPlaceUid
      }
      const orgUid =
        (data && data.orgUid) ||
        (rootState.user && rootState.user.orgValue) ||
        ''
      if (orgUid) {
        query.orgUid = orgUid
      }
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/organize/cultivate/risk',
          data: query
        },
        { root: true }
      )
      var workContentAndRisk = (res.data ? res.data : []).filter((item) => {
        const parentParts = [
          item.riskProType,
          item.riskWokeType,
          item.riskSource
        ]
        if (parentParts.some((part) => isDirtyDictLabel(part))) return false
        if (isDirtyDictLabel(item.technicalMeasures)) return false
        return true
      })
      const compareZh = (a, b) =>
        String(a || '').localeCompare(String(b || ''), 'zh-CN')
      workContentAndRisk.sort((a, b) => {
        return (
          compareZh(a.riskProType, b.riskProType) ||
          compareZh(a.riskWokeType, b.riskWokeType) ||
          compareZh(a.riskSource, b.riskSource) ||
          compareZh(
            a.technicalMeasures || a.riskFactors,
            b.technicalMeasures || b.riskFactors
          )
        )
      })
      workContentAndRisk.forEach((item) => {
        item.label =
          item.riskProType + '/' + item.riskWokeType + '/' + item.riskSource
      })
      var obj = {
        uid: 'riskWokeCode',
        label: 'label',
        childUid: 'uid',
        childLabel: data && data.labelKey ? data.labelKey : 'riskFactors',
        keepKeys: ['riskProType', 'riskWokeType', 'riskSource']
      }
      workContentAndRisk = getLevelArray(workContentAndRisk, obj)
        .map((item) => {
          item.children = (item.children || [])
            .filter((child) => {
              return !isDirtyDictLabel(child.label)
            })
            .sort((a, b) => compareZh(a.label, b.label))
          return item
        })
        .filter((item) => {
          return (
            item.label &&
            !isDirtyDictLabel(item.label) &&
            item.children &&
            item.children.length
          )
        })
        .sort((a, b) => {
          return (
            compareZh(a.riskProType, b.riskProType) ||
            compareZh(a.riskWokeType, b.riskWokeType) ||
            compareZh(a.riskSource, b.riskSource) ||
            compareZh(a.label, b.label)
          )
        })
      workContentAndRisk = uniqueWorkContentTree(workContentAndRisk)
      if (!data.silent) {
        commit(
          'baseSet',
          {
            module: 'division',
            key: 'workContentAndRisk',
            value: workContentAndRisk
          },
          { root: true }
        )
      }
      return workContentAndRisk
    }
  }
}
